export enum AccessibilityType {
  LIVE_ATTENDANCE = 'LIVE_ATTENDANCE',
  STREAMING = 'STREAMING',
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/model/accessibility-type.ts